﻿import config from "../config"
const baseUrl = config.base_mini_url + "z_sample_lighten_card/"
export default {
    verificationGift: {
        url:  baseUrl + "verificationGift?key=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9",
        type: "get",
    },
}

